var jQuery = require('jquery');
require('jquery.easing');

window.jQuery = jQuery;
window.$ = jQuery;

// require('bootstrap-five/js/dist/alert');
// require('bootstrap-five/js/dist/button');
// require('bootstrap-five/js/dist/carousel');
// require('bootstrap-five/js/dist/util');
require('bootstrap-five/js/dist/collapse');
require('bootstrap-five/js/dist/offcanvas');
// require('bootstrap-five/js/dist/popover');
// require('bootstrap-five/js/dist/accordion');
require('bootstrap-five/js/dist/dropdown');
require('bootstrap-five/js/dist/tab');
require('bootstrap-five/js/dist/modal');
// require('bootstrap-five/js/dist/tooltip');

require("jquery-ui/ui/widgets/slider");
require("jquery-ui/ui/widgets/draggable");
require('jquery-ui-touch-punch');

import Headroom from "headroom.js";

// Feather icons
// const feather = require('feather-icons');
// feather.replace();

// import Swiper from 'swiper';
// import { Navigation, Pagination, LazyLoading } from 'swiper/modules';

import Swiper from 'swiper/bundle';
window.Swiper = Swiper;

import intlTelInput from 'intl-tel-input';
window.intlTelInput = intlTelInput;

import Mmenu from 'mmenu-js';

require('bootstrap-datepicker');

const Cookies = require('js-cookie');
window.Cookies = Cookies;

require('magnific-popup');

// DOM Ready functions using custom async function so it only funs when jQuery has been fully loaded
var async = async || [];
while(async.length) { // there is some syncing to be done
    var obj = async.shift();
    if (obj[0] == 'ready') {
        $(obj[1]);
    }else if (obj[0] == 'load'){
        $(window).load(obj[1]);
    }
}
async = window.async = {
    push: function(param){
        if (param[0] == 'ready') {
            $(param[1]);
        }else if (param[0] == 'load'){
            $(window).load(param[1]);
        }
    }
};

let isMobileSelect = window.isMobileSelect = false;

var PaymentSlider;
var PriceSlider;
var PaymentSliderMin_default = window.PaymentSliderMin_default = 30;
var PaymentSliderMax_default = window.PaymentSliderMax_default = 200;
var PaymentSliderMin = window.PaymentSliderMin = $('#paymentmin').val();
var PaymentSliderMax = window.PaymentSliderMax = $('#paymentmax').val();
var PriceSliderMin_default = window.PriceSliderMin_default = 1000;
var PriceSliderMax_default = window.PriceSliderMax_default = 50000;
var PriceSliderMin = window.PriceSliderMin = $('#pricemin').val();
var PriceSliderMax = window.PriceSliderMax = $('#pricemax').val();

var TradeInPriceSliderMin_default = window.TradeInPriceSliderMin_default = 0;
var TradeInPriceSliderMax_default = window.TradeInPriceSliderMax_default = 50000;
var TradeInPriceSliderMin = window.TradeInPriceSliderMin = $('#tradeinpricemin').val();
var TradeInPriceSliderMax = window.TradeInPriceSliderMax = $('#tradeinpricemax').val();

var KmSliderMin_default = window.KmSliderMin_default = 10000;
var KmSliderMax_default = window.KmSliderMax_default = 250000;
var KmSliderMin = window.KmSliderMin = $('#kmmin').val();
var KmSliderMax = window.KmSliderMax = $('#kmmax').val();

var PurchaseVehiclePriceSliderMin = window.PurchaseVehiclePriceSliderMin = $('#purchasevehiclepricemin').val();
var PurchaseVehiclePriceSliderMax = window.PurchaseVehiclePriceSliderMax = $('#purchasevehiclepricemax').val();

var dragged = window.dragged = false;
var stocknumber = window.stocknumber = $('#stocknumber').text();

var default_term = window.default_term = 72; // 6 years
var default_interest_rate = window.default_interest_rate = 15.95;
var default_deposit = window.default_deposit = 0;
var default_frequency = window.default_frequency = 'Weekly';

let MultiselectDropdownOptions = window.MultiselectDropdownOptions = {
    placeholder: 'All',
    dropdownInput: {
        class: 'form-select',
    },
    style: {
        width: '100%',
        postion: 'relative',
    }
}

async.push(["ready", function() {

    $(window).on('scroll', function() {
        var scroll = $(window).scrollTop();
        if (scroll >= 100 ) {
            $('.birdeye-widget').removeClass('opacity-0').addClass('opacity-100');
        } else {
            $('.birdeye-widget').removeClass('opacity-100').addClass('opacity-0');
        }
    });

    // sticky mobile header / footer
    initHeadroom();

    $('.select-newscategory').on('change', function(e){
        e.stopPropagation();
        let category = $(this).val();
        let path = $(this).data('path');
        document.location.href = path + category;
    });

    // Scroll to functionality for .scroll-to elements
    $('.scroll-to').on('click', function(e) {
        e.preventDefault();
        var target = $(this).attr('href');
        var offset = $(window).width() > 992 ? 100 : 0; // Set offset based on screen width
        $('html, body').animate({
            scrollTop: $(target).offset().top - offset
        }, 600);
    });

    // $(window).on('resize', function() {
    //     initListingMetaTextTruncate();
    // });
    // $('#toggle-tt').on('click', function(e) {
    //     console.log('toggle-tt');
    //     var target = $($(this).data('target'));
    //     if (target.hasClass('text-truncate-multiline')) {
    //         target.removeClass('text-truncate-multiline');
    //         $(this).text('Read less');
    //     } else {
    //         target.addClass('text-truncate-multiline');
    //         $(this).text('Read more');
    //     }
    // });
}]);

// Mmenu load
document.addEventListener(
    "DOMContentLoaded", () => {
        // MMENU
        const menu = new Mmenu( "#mmenu", {
            "extensions": [
                "theme-light", "position-front", "position-left"
            ],
            //slidingSubmenus: false,
        });
        const mmenuApi = menu.API;
        mmenuApi.bind('open:before', function (){
            document.documentElement.classList.add('mm-open');
            $('#header-search-mobile').removeClass('show');
        });
        mmenuApi.bind('close:after', function(){
            document.documentElement.classList.remove('mm-open');
        });

        // mobile search
        $('.btn-search-mob').on('click', function() {
            mmenuApi.close();
            $('#header-search-mobile').toggleClass('show');
        });
        $('#mmenu').removeClass('d-none');

        // Listing Meta intro text truncate
        //initListingMetaTextTruncate();

    }
);

// function initListingMetaTextTruncate() {
//     if (document.getElementById('lmeta-intro') == null) {
//         return;
//     }
//     // show/hide btn
//     if (!isOverflown(document.getElementById('lmeta-intro'))) {
//         $('#toggle-tt').addClass('d-none');
//     } else {
//         $('#toggle-tt').removeClass('d-none');
//     }
// }

function isOverflown(element) {
    return element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth;
}

function initHeadroom(){
    var mobileheader = document.getElementById('mob-header');
    // var mobilefooter = document.getElementById('footroom');
    var mobilenav = document.getElementById('mmenu');

    function isNavVisible(mobilenav) {
      return ( mobilenav.classList.contains('active') ? true : false );
    }

    var headerOptions = {
        // vertical offset in px before element is first unpinned
        offset: 150,
        onUnpin: function() {
            if ( isNavVisible(mobilenav) ) {
              this.elem.classList.remove(this.classes.unpinned);
              this.elem.classList.add(this.classes.pinned);
            }
            else {
              this.elem.classList.add(this.classes.unpinned);
              this.elem.classList.remove(this.classes.pinned);
            }
        },
        onPin: function() {
            $('.listings-search--container').addClass('lower');
        },
        onUnpin: function() {
            $('.listings-search--container').removeClass('lower');
        }
    };

    // Sticky header show/hide on scroll
    const headroom = window.headroom = new Headroom(mobileheader, headerOptions);
    headroom.init();

    // if (mobilefooter) {
    //     var footerOptions = {
    //         // vertical offset in px before element is first unpinned
    //         offset: 20,
    //         tolerance : {
    //             up : 20,
    //             down : 20
    //         },
    //         classes: {
    //             // when scrolling down
    //             unpinned: "footroom--unpinned",
    //             // when above offset
    //             top: "footroom--top",
    //         },
    //         onPin: function() {
    //             $('.compare-action').addClass('higher');
    //             $('#bewebchat').addClass('footroom-pinned');
    //         },
    //         onUnpin: function() {
    //             $('.compare-action').removeClass('higher');
    //             $('#bewebchat').removeClass('footroom-pinned');
    //         }
    //     };

    //     const footroom = window.footroom = new Headroom(mobilefooter, footerOptions);
    //     footroom.init();
    // }
}

window.processFormSubmitBtn = function processFormSubmitBtn(form, event) {
    // get the submit button that was clicked
    var btn = form.find('button[type=submit]');

    var btnText = btn.text();
    var btnLoadingText = (typeof btn.data('loading-text') !== "undefined") ? btn.data('loading-text') : 'Processing';

    // apply loading state to form submit button
    btn.html('<i class="fa fa-circle-o-notch fa-spin fa-lg"></i> ' + btnLoadingText).addClass('disabled').prop('disabled', true);

    setPhoneNumberGhosts(form);
}

window.initModalValidate = function initModalValidate() {
    $("#modal-base .form-ajax").each(function() {

        const rules = validateAjaxPhoneNumber($(this));

        // attach to all form elements in modal
        $(this).validate({
            ignore: "",
            invalidHandler: function(event, validator) {},
            errorClass: "has-error help-block",
            validClass: "has-success",
            errorElement: "span",
            rules: rules,
            errorPlacement: function(error, element) {
                if ($(element).is('select')) {
                    element.parent().before(error); // special placement for select elements
                } else {
                    error.insertBefore(element); // default placement for everything else
                }
            },
            highlight: function(element, errorClass, validClass) {
                $(element).parents("div.form-group").addClass("has-error");
            },
            unhighlight: function(element, errorClass, validClass) {
                $(element).parents(".has-error").removeClass("has-error");
            },
            submitHandler: function(form) {
                submitAjaxForm(form);
            }
        });

        $.extend($.validator.messages, {
            required: "Required",
        });
    });
}

window.recaptchaInit = function (parent) {
    let gClass = '.g-recaptcha';
    if (parent !== undefined) {
        gClass = parent + ' .g-recaptcha';
    }
    $(gClass).each(function() {
        var el = $(this);
        if (grecaptcha) {
            try {
                grecaptcha.render($(el).attr("id"), {});
            } catch(error){
                // duplicate errors
            }
        }
    });
    window.dispatchEvent(new CustomEvent('recaptcha-init'));
}

window.trackingEvent = function trackingEvent(eventName, data) {
    let event = new CustomEvent(eventName, {
        detail: data,
    });
    window.dispatchEvent(event);
}

window.triggerDataLayerEvent = function triggerDataLayerEvent(eventName, data = null) {
    // console.log('triggerDataLayerEvent', eventName);
    if (typeof dataLayer !== 'undefined') {
        dataLayer.push({
            event: eventName
        });
        if (data !== null) {
            dataLayer.push(data);
        }
    }
}

window.number_format = function(value, decimal) {
    let parsedNumber = parseFloat(value);
    if (_.isNaN(parsedNumber)) {
        return '0';
    }
    return parsedNumber.toFixed(decimal).replace(/(.)(?=(\d{3})+$)/g,'$1,');
}